




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BerkasRmService, { BerkasRm } from "@/services/BerkasRmService";
import BerkasTable from "@/components/pemeriksaan/berkasRm/BerkasTable.vue";
import DialogUploadBerkas from "@/components/pemeriksaan/berkasRm/DialogUploadBerkas.vue";

@Component({ components: { BerkasTable, DialogUploadBerkas } })
export default class BerkasFormPanel extends Vue {
  @Prop({ required: true }) rm!: string;
  @Prop({ default: "" }) register!: string;
  @Prop({ required: true }) jenisKode!: string;
  @Prop({ type: String, default: "" }) subJenisKode!: string;
  @Prop({ default: "Berkas Terunggah" }) judul!: string;
  @Prop({ type: Boolean, default: false }) readOnly!: boolean;
  @Prop({ type: String, default: "" }) sumberTipe!: string;
  @Prop({ type: [Number, String], default: null }) sumberId!:
    | number
    | string
    | null;
  @Prop({ type: Boolean, default: true }) canDelete!: boolean;
  @Prop({ type: Boolean, default: false }) hideUploadButton!: boolean;

  items: BerkasRm[] = [];
  loading = false;
  uploadOpen = false;

  get emptyText(): string {
    return `Belum ada berkas diunggah untuk dokumen ini. Tekan "Upload Berkas" untuk mengunggah hasil scan lembar yang sudah ditandatangani.`;
  }

  get rmKey(): string {
    const v = String(this.rm || "");
    return v.length > 6 ? v.slice(-6) : v;
  }

  get sumberAktif(): boolean {
    return !!this.sumberTipe && Number(this.sumberId) > 0;
  }

  mounted() {
    this.fetch();
  }

  @Watch("rm")
  @Watch("register")
  @Watch("sumberId")
  onContextChange() {
    this.fetch();
  }

  openUpload() {
    if (this.readOnly || !this.register) return;
    this.uploadOpen = true;
  }

  async fetch() {
    if (!this.rm || !this.register) {
      this.items = [];
      return;
    }

    const rm = this.rmKey;
    const register = this.register;
    const sumberId = this.sumberId;
    this.loading = true;

    try {
      const params: {
        register_id: string;
        scope: "register";
        sumber_tipe?: string;
        sumber_id?: number;
      } = { register_id: register, scope: "register" };
      if (this.sumberAktif) {
        params.sumber_tipe = this.sumberTipe;
        params.sumber_id = Number(this.sumberId);
      }

      const semua = await BerkasRmService.list(rm, params);

      if (
        this.rmKey !== rm ||
        this.register !== register ||
        this.sumberId !== sumberId
      )
        return;

      this.items = this.sumberAktif
        ? semua
        : semua.filter(b => b.jenis_berkas_kode === this.jenisKode);
      this.$emit("changed", this.items.length);
    } catch (e) {
      if (this.rmKey === rm && this.register === register) this.items = [];
    } finally {
      this.loading = false;
    }
  }

  onUploaded() {
    this.fetch();
  }

  onPreview(berkas: BerkasRm) {
    BerkasRmService.openFile(berkas.id).catch(() => undefined);
  }

  async onDelete(berkas: BerkasRm) {
    if (!confirm(`Hapus berkas "${berkas.nama_file}"?`)) return;

    try {
      await BerkasRmService.remove(berkas.id);
      this.fetch();
    } catch (e) {
      // error sudah di-handle oleh ErrorAlert di service.
    }
  }
}
